export default __webpack_public_path__ + "static/media/male_avatar.e9065ab1.png";